export const getAllCookies = () => {
	const cookies = document.cookie.split('; ');
	const allCookies = [];
	cookies.forEach((cookie) => {
		const cookieParts = cookie.split('=');
		allCookies[cookieParts[0]] = cookieParts[1];
	});

	return allCookies;
};
